import __base_store from '@/store/__base_store'

/**
 * Store de estados de venta.
 */
export default __base_store({
	state: {
		model_name: 'sale_status',
	},
})

